import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
import ReactDOM from 'react-dom';

import {ApolloProvider as ReactHooksApolloProvider} from '@apollo/react-hooks';

import {nutApolloClient} from '../../../apollo-client';

import {FormFlashBanner} from './form-flash-banner';

export function mountFormFlashBanner() {
    const formFlashBannerContainer = document.querySelector('#form-banner-react-mount');
    if (formFlashBannerContainer) {
        ReactDOM.render(
            <ApolloProvider client={nutApolloClient}>
                <ReactHooksApolloProvider client={nutApolloClient}>
                    <FormFlashBanner />
                </ReactHooksApolloProvider>
            </ApolloProvider>,
            formFlashBannerContainer
        );
    }
}
